import { CopyBlock, dracula } from "react-code-blocks"
import Button from "react-bootstrap/Button"

const htmlSnippet = `<h1 class="game-title">Your name Game</h1>
<button type="button" onClick="startGame()">Start Game</button>
<button type="button" onClick="stopGame()">Stop Game</button>
<br />`

const cssSnippet = `.game-title {
  color: green;
}`

const configSnippet = `var config = {
  type: Phaser.AUTO,
  width: 1280,
  height: 720,
  backgroundColor: "#5DACD8",
  scene: MyGame,
  physics: {
    default: "arcade",
    arcade: {
      gravity: { y: 0 },
      debug: false
    }
  }
};`

const emptyScene = `
class MyGame extends Phaser.Scene {
  preload() {
  }

  create() {
  }

  update(ts, dt) {
  }
}
`

const startStopButtons = `
var game;
function startGame() {
  if (!game) {
    game = new Phaser.Game(config);
  } else {
    game.start();
  }
}

function stopGame() {
  if (game) {
    game.destroy(true, false);
    game = null;
  }
}
`

const Config = () => (
  <>
    <h1>Configuring Phaser 3</h1>
    <p>
      We need to setup a few things to get our phaser project running. Let start
      off with a little bit of html, css, and javascript.
    </p>
    <p>In your HTML window copy and paste the code block below:</p>
    <CopyBlock
      text={htmlSnippet}
      language={"html"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      We are also going to add a little bit of css, in you css window copy and
      paste this code block below:
    </p>
    <CopyBlock
      text={cssSnippet}
      language={"css"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Now we need to create a configuration for Phaser so it knows what to do.
      Start by pasting in this configuration in the JS window
    </p>
    <CopyBlock
      text={configSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      This configuration sets up multiple things, but some highlights are the
      size of the screen we want to make for the game, default background color,
      if there is gravity, and the starting scene.
    </p>
    <p>
      Speaking of starting scene we should probably get that going. Now paste
      this code snippet above the config code we just added in the JS window.
    </p>
    <CopyBlock
      text={emptyScene}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <br />
    <p>
      There is one more thing we need to get this going, and that is a couple of
      start and stop buttons. Please past this below the configuration code:{" "}
    </p>
    <CopyBlock
      text={startStopButtons}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <br />
    <p>Your JS panel should look like this when finished: </p>
    <CopyBlock
      text={emptyScene + configSnippet + startStopButtons}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <br />
    <br />
    <Button type="button" variant="secondary" href="/Sprites">
      Next
    </Button>
    <br />
    <br />
  </>
)

export default Config
